import getMapProjection from 'helpers/map/getMapProjection'

export default function getMapDimensions(map) {
  const projection = getMapProjection(map)
  const bounds = map.getBounds()
  const cor1 = bounds.getNorthEast()
  const cor2 = bounds.getSouthWest()
  const cor1Projection = projection.fromLatLngToContainerPixel(cor1)
  const cor2Projection = projection.fromLatLngToContainerPixel(cor2)
  return {
    width: Math.abs(cor1Projection.x) + Math.abs(cor2Projection.x),
    height: Math.abs(cor1Projection.y) + Math.abs(cor2Projection.y)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/map/getMapDimensions.js